import { Pipe, PipeTransform } from '@angular/core';

/**
 * removes HTML tags from string and returns if message is empty or not
 */
@Pipe({
  name: 'isMessageEmpty',
})
export class IsMessageEmptyPipe implements PipeTransform {
  transform(body: string): boolean {
    if (!body || typeof body !== 'string') {
      return true;
    }

    const checkBody = body
      .replace(/<\/?[^>]+(>|$)/g, '')
      .replace(/\s/g, '')
      .replace(/&nbsp;/g, '');
    return body === '' || checkBody === '';
  }
}
